<template>
  <div id="wrap">
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header />
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit">
        <h1>커뮤니티</h1>
      </div>

      <div class="hp_productMain_contentWrap">
        <!-- Sidebar -->
        <div class="hp_productMain_contentSidebar">
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu">
              <li>
                <a href="/Community?communityID=1">공지사항</a>
              </li>
              <li class='hp_productMain_contentMenu_active'>
                <a href="/Community?communityID=2">여행후기</a>
              </li>
              <li>
                <a href="/Community?communityID=3">온라인문의</a>
              </li>
              <li>
                <a href="/Community?communityID=4">자주 묻는 질문</a>
              </li>
              <li>
                <a href="/Community?communityID=5">단체여행문의</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 여행후기 상세 -->
        <div class="hp_commuBody">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            여행후기
          </div>
          <div class="hp_commuWrap">
            <!-- 검색 기능 -->
            <div class="hp_commu_searchBox hp_MobNonePcBlock">
              <input
                type="text"
                maxLength="20"
                v-model="statusData.travelReviewSearch"
                placeholder="검색어를 입력하세요"
                @keypress.enter="searchNotice()" />
              <button @click="searchNotice()">검색</button>
            </div>
            <!-- 상세_타이틀 -->
            <div class="hp_commuDetail_titBox">
              {{statusData.travelReviewData.travel_review_title}}
              <p class="hp_commuDetail_titBoxData">
                작성자: {{statusData.travelReviewData.travel_review_write}} | 작성일: {{statusData.travelReviewData.travel_review_registe}} | 조회수: {{statusData.travelReviewData.travel_review_views}}
              </p>
            </div>

            <!-- 상세_에디터뷰 -->
            <div class="hp_commuDetail_content">
              <div v-editor-html="statusData.travelReviewData.travel_review_editor"/>
            </div>

            <div class="hp_commuDetail_BtnBox">
              <a
                v-if="statusData.travelReviewData.customer_ID_use_travel_review === sessionData.customer.customer_ID"
                @click="editTravelReview(statusData.travelReviewData.customer_ID_use_travel_review)">
                수정
              </a>
              <a
                v-if="statusData.travelReviewData.customer_ID_use_travel_review === sessionData.customer.customer_ID"
                @click="deleteTravelReview(statusData.travelReviewData.customer_ID_use_travel_review)"
                class="hp_commuDetail_BtnBox_del">
                삭제
              </a>
              <a href="/Community?communityID=2" class="hp_commuDetail_BtnBox_list">목록</a>
            </div>

            <!-- 댓글 작성 -->
            <div class="hp_commuDetail_commentWrite" v-if="sessionData.customer !== ''">
              <div class="hp_commuDetail_cwInput">
                <input type="text" name="name" placeholder="이름" v-model="formData.name"/>
                <input type="password" name="password" placeholder="비밀번호" v-model="formData.password"/>
              </div>
              <div class="hp_commuDetail_cwTextarea">
                <textarea placeholder="남기실말씀을 적어주세요." v-model="formData.content" />
                <button type="submit"  @click="validateForm">등록하기</button>
              </div>
              <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
                <div class="hp_commuDetail_pbAll">
                  <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
                  <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
                </div>
                <div class="hp_commuDetail_pbEarch">
                  <div>
                    <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
                    <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
                  </div>
                  <button type="button" @click="togglePopup(1)">약관보기</button>
                </div>
                <div class="hp_commuDetail_pbEarch">
                  <div>
                    <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
                    <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
                  </div>
                  <button type="button" @click="togglePopup(2)">약관보기</button>
                </div>
                <div class="hp_commuDetail_pbEarch">
                  <div>
                    <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
                    <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
                  </div>
                  <button type="button" @click="togglePopup(3)">약관보기</button>
                </div>
              </div>
            </div>

            <!-- 댓글 리스트 -->
            <div class="hp_commuDetail_commentList">
              <div v-for="comment in statusData.travelReviewCommentData" :key="comment.travel_review_comment_ID" class="hp_commuDetail_clBox">
                <div class="hp_commuDetail_clBoxTit">
                  <span class="hp_commuDetail_clBoxTit_user">{{ comment.travel_review_comment_name }}</span>
                  <span class="hp_commuDetail_clBoxTit_date">{{ comment.travel_review_comment_registe }}</span>
                  <button
                    class="hp_commuDetail_clBoxTit_del"
                    @click="deleteComment(comment.customer_ID_use_travel_review_comment, comment.travel_review_comment_ID)">
                    닫기
                  </button>
                </div>
                <div class="hp_commuDetail_clBox_content">
                  <p>{{ comment.travel_review_comment_content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 여행후기  -->
      </div>
    </div>
    <PopupComponent
      :isVisible="statusData.isPopupVisible"
      :toggleStatus="statusData.toggleStatus"
      @update:isVisible="statusData.isPopupVisible = $event"
    />
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '..//Section/Spiner.vue'
import PopupComponent from '../Section/PopupComponent.vue'
import {
  get_session_customer,
  get_hot_keyword_top10,
  get_travel_review_one,
  update_travel_review_views_count,
  insert_travel_review_comment,
  delete_travel_review_comment,
  update_travel_review_status
} from '../../ETC/Axios.vue'

export default {
  name: 'TravelReviewDetail',
  components: {
    Header,
    Footer,
    Scroll,
    Spiner,
    PopupComponent
  },
  data () {
    return {
      formData: {
        agreeAll: false,
        agree1: false,
        agree2: false,
        agree3: false,
        name: '',
        password: '',
        content: ''
      },
      statusData: {
        hotKeywordData: [],
        travelReviewSearch: '',
        travelReviewData: {},
        travelReviewCommentData: [],
        isPopupVisible: false,
        toggleStatus: 1,
        spinnerStatus: false
      },
      sessionData: {
        customer: ''
      }
    }
  },
  methods: {
    searchNotice () {
      this.$router.push(`/Community?communityID=2&travelReviewSearch=${encodeURIComponent(this.statusData.travelReviewSearch)}`)
    },
    togglePopup (toggleStatus) {
      this.statusData.toggleStatus = toggleStatus
      this.statusData.isPopupVisible = true
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    validateForm () {
      if (!this.formData.name) {
        alert('이름을 입력해주세요.')
        return
      }
      if (!this.formData.password) {
        alert('비밀번호를 입력해주세요.')
        return
      }
      if (!this.formData.content) {
        alert('남기실 말씀을 입력해주세요.')
        return
      }
      if (!this.formData.agree1 || !this.formData.agree2 || !this.formData.agree3) {
        alert('모든 필수 동의 항목에 체크해주세요.')
        return
      }
      this.submitForm()
    },
    submitForm () {
      this.statusData.spinnerStatus = true
      insert_travel_review_comment(
        this.sessionData.customer.customer_ID,
        this.$route.query.travel_review_ID,
        this.formData.name,
        this.formData.password,
        this.formData.content
      ).then(() => {
        this.statusData.spinnerStatus = false
        alert('등록이 완료되었습니다.')
        window.location.reload()
      })
    },
    deleteComment (customer_ID_use_travel_review_comment, travel_review_comment_ID) {
      if (customer_ID_use_travel_review_comment !== this.sessionData.customer.customer_ID && this.sessionData.customer.customer_super_status !== 1) {
        alert('본인이 작성한 댓글만 삭제할 수 있습니다.')
      } else {
        const confirmDelete = window.confirm('정말 삭제하시겠습니까?')
        if (confirmDelete) {
          this.statusData.spinnerStatus = true
          delete_travel_review_comment(
            travel_review_comment_ID
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('삭제가 완료되었습니다.')
            window.location.reload()
          })
        }
      }
    },
    editTravelReview (customer_ID_use_travel_review) {
      if (customer_ID_use_travel_review !== this.sessionData.customer.customer_ID) {
        alert('본인이 작성한 글만 수정할 수 있습니다.')
      } else {
        window.location.href = `/CommunityWrite?communityID=2&travel_review_ID=${this.$route.query.travel_review_ID}`
      }
    },
    deleteTravelReview (customer_ID_use_travel_review) {
      if (customer_ID_use_travel_review !== this.sessionData.customer.customer_ID) {
        alert('본인이 작성한 글만 수정할 수 있습니다.')
      } else {
        const confirmDelete = window.confirm('정말 삭제하시겠습니까?')
        if (confirmDelete) {
          this.statusData.spinnerStatus = true
          update_travel_review_status(
            this.$route.query.travel_review_ID,
            '2'
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('삭제가 완료되었습니다.')
            window.location.href = '/Community?communityID=2'
          })
        }
      }
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    get_session_customer().then(result_session => {
      this.sessionData.customer = result_session
      update_travel_review_views_count(this.$route.query.travel_review_ID).then(result_travel_review_views_count => {
        get_travel_review_one(this.$route.query.travel_review_ID).then(result => {
          if (result.travel_review[0].travel_review_security_status === 1 &&
          result.travel_review[0].customer_ID_use_travel_review !== result_session.customer_ID &&
          this.sessionData.customer.customer_super_status !== 1
          ) {
            alert('본인이 작성한 글만 확인할 수 있습니다.')
            window.location.href = '/Community?communityID=2'
          } else {
            this.statusData.travelReviewData = result.travel_review[0]
            this.statusData.travelReviewCommentData = result.comments
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Community/TravelReviewDetail.vue